import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import type { MutationRedirectStatsArgs } from "@/types/graphql";
/**
 * Custom hook to fetch redirect stats.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{redirectStats: Function, loading: boolean}} - The function to fetch redirect stats and the loading state.
 */
export function useRedirectStats(
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const [comRedirectStats, { loading }] = useMutation<any>(
    mutations.redirectStats,
    {
      onCompleted: (data: any) => {
        const statsRes = data?.redirectStats || data?.comRedirectStats;
        if (statsRes?.success) {
          onCompleted(statsRes.result);
        }
      },
      onError,
    },
  );

  const redirectStats = useCallback(
    async (variables: MutationRedirectStatsArgs) => {
      await comRedirectStats({
        variables,
      });
    },
    [comRedirectStats],
  );

  return {
    redirectStats,
    loading,
  };
}
